<template>
    <div class="titulo">
        <div class="margem container dashboard-full-width">
            <div class="m-icone direita">
                <div class="pesquisa"></div>
            </div>
            <h2>Indicadores - Projetos</h2>
        </div>
    </div>
    <div class="margem dashboard-full-width">
        <!-- Filtros -->
        <FiltrosIndicadoresProjetos :filtros="filtrosLocais" :projetos-disponiveis="projetosDisponiveis"
            :gerentes-disponiveis="gerentesDisponiveis" :status-disponiveis="statusDisponiveis"
            :setores-disponiveis="setoresDisponiveis" @aplicar-filtros="aplicarFiltrosHandler"
            @limpar-filtros="limparFiltros" />

        <!-- Dashboard de Gráficos -->
        <div class="bloco margem">
            <GraficosIndicadoresProjetos :projetos="projetosFiltrados" @clicar-projeto="abrirDetalhesProjeto" />
        </div>

    </div>

    <!-- Modal de Detalhes do Projeto -->
    <ModalDetalhesProjeto :projeto="projetoDetalhes" @fechar="fecharModal" />

    <!-- Modal de Tarefas -->
    <ModalDetalhesTarefas :projeto="modalTarefas" @fechar="fecharModalTarefas" />
</template>

<script>
import { useApiError } from "@/composables/useApiError";
import serviceProjetos from "@/services/serviceProjetos";
import GraficosIndicadoresProjetos from "@/components/Graficos/GraficosIndicadoresProjetos.vue";
import FiltrosIndicadoresProjetos from "@/components/Filtros/FiltrosIndicadoresProjetos.vue";
import ModalDetalhesProjeto from "@/components/Modais/ModalDetalhesProjeto.vue";
import ModalDetalhesTarefas from "@/components/Modais/ModalDetalhesTarefas.vue";

export default {
    components: {
        GraficosIndicadoresProjetos,
        FiltrosIndicadoresProjetos,
        ModalDetalhesProjeto,
        ModalDetalhesTarefas,
    },

    setup() {
        const { handleError } = useApiError({ message: "Não foi possível buscar os projetos." });
        return { handleApiError: handleError };
    },

    data() {
        // Define dataInicioInicial como 01 de janeiro do ano atual
        const anoAtual = new Date().getFullYear();
        const dataInicioInicialPadrao = `${anoAtual}-01-01`;

        return {
            projetos: [],
            projetosPaginados: null,
            filtroProjeto: [],
            filtroGerente: [],
            filtroStatus: ['Em andamento'],
            filtroSetor: [],
            filtroBusca: '',
            filtroEncerrado: '',
            dataInicioInicial: dataInicioInicialPadrao,
            dataInicioFinal: '',
            dataTerminoInicial: '',
            dataTerminoFinal: '',
            projetosDisponiveis: [],
            gerentesDisponiveis: [],
            statusDisponiveis: ['Aprovado', 'Concluído', 'Em andamento', 'Proposto', 'suspenso'],
            setoresDisponiveis: [],
            projetoDetalhes: null,
            modalTarefas: null
        }
    },
    mounted() {
        this.getProjetos();
    },
    watch: {
        filtroProjeto: 'getProjetos',
        filtroGerente: 'getProjetos',
        filtroStatus: 'getProjetos',
        filtroSetor: 'getProjetos',
        filtroEncerrado: 'getProjetos',
        filtroBusca: 'getProjetos',
        dataInicioInicial: 'getProjetos',
        dataInicioFinal: 'getProjetos',
        dataTerminoInicial: 'getProjetos',
        dataTerminoFinal: 'getProjetos',
    },
    computed: {
        filtrosLocais() {
            return {
                projeto: this.filtroProjeto,
                gerente: this.filtroGerente,
                status: this.filtroStatus,
                setor: this.filtroSetor,
                busca: this.filtroBusca,
                encerrado: this.filtroEncerrado,
                dataInicioInicial: this.dataInicioInicial,
                dataInicioFinal: this.dataInicioFinal,
                dataTerminoInicial: this.dataTerminoInicial,
                dataTerminoFinal: this.dataTerminoFinal
            };
        },
        projetosFiltrados() {
            return this.projetos.filter(p => {
                const passaProjeto = this.filtroProjeto.length === 0 || this.filtroProjeto.includes(p.id);
                const passaGerente = this.filtroGerente.length === 0 || (p.gerente && this.filtroGerente.includes(p.gerente.id));
                const passaStatus = this.filtroStatus.length === 0 || this.filtroStatus.includes(p.status);
                const passaSetor = this.filtroSetor.length === 0 || (p.setor && this.filtroSetor.includes(p.setor.id));
                const passaEncerrado = this.filtroEncerrado === '' || p.encerrado == this.filtroEncerrado;

                const busca = (this.filtroBusca ?? '').toLowerCase();
                const passaBusca = !busca ||
                    (p.nome ?? '').toLowerCase().includes(busca) ||
                    (p.pcm?.codigo ?? '').toLowerCase().includes(busca);

                const dentroIntervalo = (dataStr, iniStr, fimStr) => {
                    if (!iniStr && !fimStr) return true;
                    if (!dataStr) return false;
                    const d = new Date(dataStr);
                    if (Number.isNaN(d.getTime())) return false;
                    if (iniStr) {
                        const ini = new Date(iniStr + 'T00:00:00');
                        if (d < ini) return false;
                    }
                    if (fimStr) {
                        const fim = new Date(fimStr + 'T23:59:59');
                        if (d > fim) return false;
                    }
                    return true;
                };

                // Usar datas do PCM para filtros de início e fim previsto
                const dtInicioFiltro = p.pcm?.dtInicio || p.dtInicio;
                const dtTerminoFiltro = p.pcm?.dtEstimadaFinal || p.dtTermino;
                const passaDtInicio = dentroIntervalo(dtInicioFiltro, this.dataInicioInicial, this.dataInicioFinal);
                const passaDtTermino = dentroIntervalo(dtTerminoFiltro, this.dataTerminoInicial, this.dataTerminoFinal);

                return passaProjeto && passaGerente && passaStatus && passaSetor && passaEncerrado && passaBusca && passaDtInicio && passaDtTermino;
            });
        },
        projetosEmAndamento() {
            return this.projetosFiltrados.filter(p => p.status === 'Em Andamento').length;
        },
        mediaConformidadePrazo() {
            const projetosComTarefas = this.projetosFiltrados.filter(p => (p.estatisticas?.tarefas?.total ?? 0) > 0);
            if (projetosComTarefas.length === 0) return 0;
            const soma = projetosComTarefas.reduce((acc, p) => acc + (p.estatisticas?.tarefas?.porcentagem_concluidas ?? 0), 0);
            return Math.round(soma / projetosComTarefas.length);
        },
        custoTotal() {
            return this.projetosFiltrados.reduce((acc, p) => acc + (p.custo_total ?? 0), 0);
        },
        totalTarefasAtrasadas() {
            return this.projetosFiltrados.reduce((acc, p) => acc + (p.estatisticas?.tarefas?.atrasadas ?? 0), 0);
        },
        alertas() {
            const alertasArray = [];
            const hoje = new Date();
            hoje.setHours(0, 0, 0, 0);

            this.projetosFiltrados.forEach(p => {
                const nomeProjeto = this.formatarNomeProjetoAlerta(p);

                // Verificar se o projeto tem PCM cadastrado
                const temPCM = p.pcm && p.pcm.id;
                const dtInicioPCM = p.pcm?.dtInicio || null;
                const dtEstimadaFinal = p.pcm?.dtEstimadaFinal || null;
                const estimativaCusto = p.pcm?.estimativa_custo || null;

                // Alertas sobre gráficos que não aparecerão

                // 1. Projeto sem PCM - não aparece em vários gráficos
                if (!temPCM) {
                    alertasArray.push({
                        id: `sem-pcm-${p.id}`,
                        projetoId: p.id,
                        projetoNome: nomeProjeto,
                        tipo: 'critico',
                        titulo: 'Projeto não aparece em gráficos',
                        mensagem: `O projeto "${nomeProjeto}" não está aparecendo nos gráficos de IPP, IPC, Projetos Atrasados, Status Prazo e Conformidade de Custo pois não possui PCM cadastrado.`,
                        valor: 'PCM não informado'
                    });
                } else {
                    // 2. IPP requer dtInicio E dtEstimadaFinal
                    if (!dtInicioPCM || !dtEstimadaFinal) {
                        const camposFaltando = [];
                        if (!dtInicioPCM) camposFaltando.push('dtInicio');
                        if (!dtEstimadaFinal) camposFaltando.push('dtEstimadaFinal');

                        alertasArray.push({
                            id: `ipp-dados-faltando-${p.id}`,
                            projetoId: p.id,
                            projetoNome: nomeProjeto,
                            tipo: 'critico',
                            titulo: 'Projeto não aparece no gráfico de IPP',
                            mensagem: `O projeto "${nomeProjeto}" não está aparecendo no gráfico de Índice de Performance de Prazo (IPP) pois o(s) campo(s) ${camposFaltando.join(' e ')} do PCM está(ão) vazio(s).`,
                            valor: `Campos faltando: ${camposFaltando.join(', ')}`
                        });
                    }

                    // 3. IPC requer estimativa_custo
                    if (!estimativaCusto) {
                        alertasArray.push({
                            id: `ipc-dados-faltando-${p.id}`,
                            projetoId: p.id,
                            projetoNome: nomeProjeto,
                            tipo: 'critico',
                            titulo: 'Projeto não aparece no gráfico de IPC',
                            mensagem: `O projeto "${nomeProjeto}" não está aparecendo no gráfico de Índice de Performance de Custo (IPC) pois o campo estimativa_custo do PCM está vazio.`,
                            valor: 'estimativa_custo não informado'
                        });
                    }

                    // 4. Projetos Atrasados requer dtEstimadaFinal
                    if (!dtEstimadaFinal) {
                        alertasArray.push({
                            id: `projetos-atrasados-dados-faltando-${p.id}`,
                            projetoId: p.id,
                            projetoNome: nomeProjeto,
                            tipo: 'critico',
                            titulo: 'Projeto não aparece no gráfico de Projetos Atrasados',
                            mensagem: `O projeto "${nomeProjeto}" não está aparecendo no gráfico de Projetos Atrasados pois o campo dtEstimadaFinal do PCM está vazio.`,
                            valor: 'dtEstimadaFinal não informado'
                        });
                    }

                    // 5. Status Prazo Projetos requer dtEstimadaFinal
                    if (!dtEstimadaFinal) {
                        alertasArray.push({
                            id: `status-prazo-dados-faltando-${p.id}`,
                            projetoId: p.id,
                            projetoNome: nomeProjeto,
                            tipo: 'critico',
                            titulo: 'Projeto não aparece no gráfico de Status Prazo',
                            mensagem: `O projeto "${nomeProjeto}" não está aparecendo no gráfico de Status Prazo Projetos pois o campo dtEstimadaFinal do PCM está vazio.`,
                            valor: 'dtEstimadaFinal não informado'
                        });
                    }

                    // 6. Conformidade de Custo requer estimativa_custo (através do IPC)
                    if (!estimativaCusto) {
                        alertasArray.push({
                            id: `conformidade-custo-dados-faltando-${p.id}`,
                            projetoId: p.id,
                            projetoNome: nomeProjeto,
                            tipo: 'critico',
                            titulo: 'Projeto não aparece no gráfico de Conformidade de Custo',
                            mensagem: `O projeto "${nomeProjeto}" não está aparecendo no gráfico de Conformidade de Custo pois o campo estimativa_custo do PCM está vazio.`,
                            valor: 'estimativa_custo não informado'
                        });
                    }
                }

                // Alertas sobre dados obrigatórios (para outros fins além dos gráficos)

                // 7. Data de Início do projeto faltando
                if (!dtInicioPCM) {
                    alertasArray.push({
                        id: `dt-inicio-pcm-faltando-${p.id}`,
                        projetoId: p.id,
                        projetoNome: nomeProjeto,
                        tipo: 'critico',
                        titulo: 'Data de Início do Projeto Faltando',
                        mensagem: `O projeto não possui data de início cadastrada no PCM.`,
                        valor: 'Data obrigatória não informada'
                    });
                }

                // 8. Data Estimada Final do projeto faltando
                if (!dtEstimadaFinal) {
                    alertasArray.push({
                        id: `dt-estimada-final-faltando-${p.id}`,
                        projetoId: p.id,
                        projetoNome: nomeProjeto,
                        tipo: 'critico',
                        titulo: 'Data Estimada Final do Projeto Faltando',
                        mensagem: `O projeto não possui data estimada final cadastrada no PCM.`,
                        valor: 'Data obrigatória não informada'
                    });
                }

                // 9. Projeto atrasado (usando dtEstimadaFinal do PCM)
                if (dtEstimadaFinal && !p.encerrado) {
                    const termino = new Date(dtEstimadaFinal);
                    termino.setHours(0, 0, 0, 0);
                    if (termino < hoje) {
                        const diasAtraso = Math.ceil((hoje - termino) / (1000 * 60 * 60 * 24));
                        alertasArray.push({
                            id: `atraso-${p.id}`,
                            projetoId: p.id,
                            projetoNome: nomeProjeto,
                            tipo: 'critico',
                            titulo: 'Projeto Atrasado',
                            mensagem: `O projeto está com prazo vencido e ainda não foi concluído.`,
                            valor: `${diasAtraso} dia(s) de atraso`
                        });
                    }
                }

                // 11. Tarefas atrasadas
                if ((p.estatisticas?.tarefas?.atrasadas ?? 0) > 0) {
                    alertasArray.push({
                        id: `tarefas-atrasadas-${p.id}`,
                        projetoId: p.id,
                        projetoNome: nomeProjeto,
                        tipo: p.estatisticas.tarefas.atrasadas > 5 ? 'critico' : 'atencao',
                        titulo: 'Tarefas Atrasadas',
                        mensagem: `Existem tarefas com prazo vencido no projeto.`,
                        valor: `${p.estatisticas.tarefas.atrasadas} tarefa(s) atrasada(s)`
                    });
                }

                // 12. Entregas atrasadas
                if (p.entregas && Array.isArray(p.entregas)) {
                    const entregasAtrasadas = p.entregas.filter(entrega => {
                        if (!entrega.dtFim || entrega.status === 'Concluído' || entrega.status === 'Cancelada') return false;
                        const dtFim = new Date(entrega.dtFim);
                        dtFim.setHours(0, 0, 0, 0);
                        return dtFim < hoje;
                    });

                    if (entregasAtrasadas.length > 0) {
                        alertasArray.push({
                            id: `entregas-atrasadas-${p.id}`,
                            projetoId: p.id,
                            projetoNome: nomeProjeto,
                            tipo: entregasAtrasadas.length > 3 ? 'critico' : 'atencao',
                            titulo: 'Pacotes de trabalho atrasados',
                            mensagem: `Existem pacotes de trabalho com prazo vencido no projeto.`,
                            valor: `${entregasAtrasadas.length} pacote(s) de trabalho atrasado(s)`
                        });
                    }
                }

                // 13. Datas incompatíveis: Tarefas com fim após o fim da entrega
                if (p.entregas && Array.isArray(p.entregas)) {
                    p.entregas.forEach(entrega => {
                        if (!entrega.dtFim) return;
                        const dtFimEntrega = new Date(entrega.dtFim);
                        dtFimEntrega.setHours(0, 0, 0, 0);

                        if (entrega.sprints && Array.isArray(entrega.sprints)) {
                            entrega.sprints.forEach(sprint => {
                                if (sprint.tarefas && Array.isArray(sprint.tarefas)) {
                                    const tarefasIncompativeis = sprint.tarefas.filter(tarefa => {
                                        if (!tarefa.dtFim) return false;
                                        const dtFimTarefa = new Date(tarefa.dtFim);
                                        dtFimTarefa.setHours(0, 0, 0, 0);
                                        return dtFimTarefa > dtFimEntrega;
                                    });

                                    if (tarefasIncompativeis.length > 0) {
                                        alertasArray.push({
                                            id: `tarefas-apos-entrega-${p.id}-${entrega.id}`,
                                            projetoId: p.id,
                                            projetoNome: nomeProjeto,
                                            tipo: 'critico',
                                            titulo: 'Datas incompatíveis: tarefas após o pacote de trabalho',
                                            mensagem: `O pacote de trabalho "${entrega.nome || 'Sem nome'}" possui tarefas com data de fim prevista após a data de fim do pacote de trabalho.`,
                                            valor: `${tarefasIncompativeis.length} tarefa(s) incompatível(is)`
                                        });
                                    }
                                }
                            });
                        }
                    });
                }

                // 14. Datas incompatíveis: Entregas com fim após o fim previsto do projeto (dtEstimadaFinal do PCM)
                if (dtEstimadaFinal && p.entregas && Array.isArray(p.entregas)) {
                    const dtLimiteProjeto = new Date(dtEstimadaFinal);
                    dtLimiteProjeto.setHours(0, 0, 0, 0);

                    const entregasIncompativeis = p.entregas.filter(entrega => {
                        if (!entrega.dtFim) return false;
                        const dtFimEntrega = new Date(entrega.dtFim);
                        dtFimEntrega.setHours(0, 0, 0, 0);
                        return dtFimEntrega > dtLimiteProjeto;
                    });

                    if (entregasIncompativeis.length > 0) {
                        alertasArray.push({
                            id: `entregas-apos-projeto-${p.id}`,
                            projetoId: p.id,
                            projetoNome: nomeProjeto,
                            tipo: 'critico',
                            titulo: 'Datas incompatíveis: pacotes de trabalho após o projeto',
                            mensagem: `Existem pacotes de trabalho com data de fim prevista após a data limite de implementação do projeto.`,
                            valor: `${entregasIncompativeis.length} pacote(s) de trabalho incompatível(is)`
                        });
                    }
                }

                // 15. Dados inconsistentes: Sem gerente
                if (!p.gerente || !p.gerente.id) {
                    alertasArray.push({
                        id: `sem-gerente-${p.id}`,
                        projetoId: p.id,
                        projetoNome: nomeProjeto,
                        tipo: 'atencao',
                        titulo: 'Dados Inconsistentes',
                        mensagem: `Projeto sem gerente cadastrado.`,
                        valor: 'Gerente não informado'
                    });
                }

                // 16. Dados inconsistentes: Sem entregas
                if (!p.entregas || (Array.isArray(p.entregas) && p.entregas.length === 0)) {
                    alertasArray.push({
                        id: `sem-entregas-${p.id}`,
                        projetoId: p.id,
                        projetoNome: nomeProjeto,
                        tipo: 'atencao',
                        titulo: 'Dados Inconsistentes',
                        mensagem: `Projeto sem pacotes de trabalho cadastrados.`,
                        valor: 'Nenhum pacote de trabalho cadastrado'
                    });
                }

                // 17. Dados inconsistentes: Sem tarefas
                if ((p.estatisticas?.tarefas?.total ?? 0) === 0) {
                    alertasArray.push({
                        id: `sem-tarefas-${p.id}`,
                        projetoId: p.id,
                        projetoNome: nomeProjeto,
                        tipo: 'atencao',
                        titulo: 'Dados Inconsistentes',
                        mensagem: `Projeto sem tarefas cadastradas.`,
                        valor: 'Nenhuma tarefa cadastrada'
                    });
                }

                // 18. Baixa conformidade de prazo (usando dtEstimadaFinal do PCM)
                const porcentagem = p.estatisticas?.tarefas?.porcentagem_concluidas ?? 0;
                if (dtEstimadaFinal) {
                    const termino = new Date(dtEstimadaFinal);
                    termino.setHours(0, 0, 0, 0);
                    const diasParaTermino = Math.ceil((termino - hoje) / (1000 * 60 * 60 * 24));

                    if (porcentagem < 50 && diasParaTermino < 30 && diasParaTermino > 0 && !p.encerrado) {
                        alertasArray.push({
                            id: `baixa-conformidade-${p.id}`,
                            projetoId: p.id,
                            projetoNome: nomeProjeto,
                            tipo: 'atencao',
                            titulo: 'Risco de Atraso',
                            mensagem: `Projeto com baixo percentual de conclusão e prazo próximo.`,
                            valor: `${porcentagem}% concluído, ${diasParaTermino} dias restantes`
                        });
                    }
                }

                // 19. Alto custo
                if ((parseFloat(p.custo_total) || 0) > 100000) {
                    alertasArray.push({
                        id: `alto-custo-${p.id}`,
                        projetoId: p.id,
                        projetoNome: nomeProjeto,
                        tipo: 'atencao',
                        titulo: 'Alto Custo',
                        mensagem: `Projeto com custo total elevado.`,
                        valor: this.formatarMoeda(p.custo_total)
                    });
                }
            });

            // Ordenar por criticidade: críticos primeiro, depois atenção
            return alertasArray.sort((a, b) => {
                if (a.tipo === 'critico' && b.tipo !== 'critico') return -1;
                if (a.tipo !== 'critico' && b.tipo === 'critico') return 1;
                return 0; // Manter ordem original dentro do mesmo tipo
            });
        }
    },
    methods: {
        formatarNomeProjetoAlerta(projeto) {
            const codigoPCM = projeto.pcm?.codigo || '';
            const nome = projeto.nome || 'Sem nome';
            return codigoPCM ? `${codigoPCM} - ${nome}` : nome;
        },
        async getProjetos() {
            try {
                const params = {
                    per_page: 1000 // Buscar mais projetos para análise completa
                };

                if (this.filtroProjeto && this.filtroProjeto.length > 0) params.projetos = this.filtroProjeto;
                if (this.filtroGerente && this.filtroGerente.length > 0) params.gerentes = this.filtroGerente;
                if (this.filtroStatus && this.filtroStatus.length > 0) params.status = this.filtroStatus;
                if (this.filtroSetor && this.filtroSetor.length > 0) params.setores = this.filtroSetor;
                if (this.dataInicioInicial) params.dt_inicio_inicio = this.dataInicioInicial
                if (this.dataInicioFinal) params.dt_inicio_fim = this.dataInicioFinal
                if (this.dataTerminoInicial) params.dt_termino_inicio = this.dataTerminoInicial
                if (this.dataTerminoFinal) params.dt_termino_fim = this.dataTerminoFinal
                if (this.filtroEncerrado !== '') {
                    params.encerrado = this.filtroEncerrado === 'true';
                }
                if (this.filtroBusca) params.search = this.filtroBusca;

                const response = await serviceProjetos.listarProjetosIndicadores(params);

                // A resposta pode vir paginada ou como array direto
                const projetosData = response.data ? response.data : (Array.isArray(response) ? response : []);

                if (projetosData.length > 0) {
                    this.projetos = projetosData.map(p => {
                        // Adicionar alertas ao projeto
                        const alertasProj = [];
                        if (p.estatisticas?.tempo?.esta_atrasado) {
                            alertasProj.push('atrasado');
                        }
                        if ((p.estatisticas?.tarefas?.atrasadas ?? 0) > 0) {
                            alertasProj.push('tarefas-atrasadas');
                        }
                        return {
                            ...p,
                            temAlerta: alertasProj.length > 0,
                            alertas: alertasProj
                        };
                    });
                    this.projetosPaginados = response;
                } else {
                    this.projetos = [];
                }

                // Preencher filtros disponíveis
                const projetos = projetosData;
                const gerentes = new Set();
                const status = new Set();
                const setores = new Set();

                projetos.forEach(p => {
                    if (p.gerente) gerentes.add(JSON.stringify({ id: p.gerente.id, name: p.gerente.name }));
                    if (p.status) status.add(p.status);
                    if (p.setor) setores.add(JSON.stringify({ id: p.setor.id, nome: p.setor.nome }));
                });

                this.projetosDisponiveis = projetos.map(p => {
                    const codigoPCM = p.pcm?.codigo || '';
                    const nome = p.nome || 'Sem nome';
                    const label = codigoPCM ? `${codigoPCM} - ${nome}` : nome;
                    return { id: p.id, nome: label };
                });
                this.gerentesDisponiveis = [...gerentes].map(g => JSON.parse(g)).sort((a, b) => a.name.localeCompare(b.name));
                // statusDisponiveis agora é uma lista fixa, não precisa mais preencher dinamicamente
                this.setoresDisponiveis = [...setores].map(s => JSON.parse(s)).sort((a, b) => a.nome.localeCompare(b.nome));
            } catch (error) {
                this.handleApiError(error);
            }
        },
        aplicarFiltrosHandler(filtros) {
            // Atualizar os filtros locais com os valores do componente de filtros
            this.filtroProjeto = filtros.projeto || [];
            this.filtroGerente = filtros.gerente || [];
            // Permite status vazio para buscar todos os projetos
            this.filtroStatus = filtros.status || [];
            this.filtroSetor = filtros.setor || [];
            this.filtroBusca = filtros.busca || '';
            this.filtroEncerrado = filtros.encerrado || '';
            this.dataInicioInicial = filtros.dataInicioInicial || '';
            this.dataInicioFinal = filtros.dataInicioFinal || '';
            this.dataTerminoInicial = filtros.dataTerminoInicial || '';
            this.dataTerminoFinal = filtros.dataTerminoFinal || '';
            // Os filtros são aplicados automaticamente via watchers
            this.getProjetos();
        },
        limparFiltros() {
            // Define dataInicioInicial como 01 de janeiro do ano atual
            const anoAtual = new Date().getFullYear();
            const dataInicioInicialPadrao = `${anoAtual}-01-01`;

            this.filtroProjeto = [];
            this.filtroGerente = [];
            this.filtroStatus = ['Em andamento'];
            this.filtroSetor = [];
            this.filtroBusca = '';
            this.filtroEncerrado = '';
            this.dataInicioInicial = dataInicioInicialPadrao;
            this.dataInicioFinal = '';
            this.dataTerminoInicial = '';
            this.dataTerminoFinal = '';
            this.getProjetos();
        },
        formatarMoeda(valor) {
            if (!valor) return 'R$ 0,00';
            return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor);
        },
        abrirDetalhesProjeto(projetoId) {
            this.projetoDetalhes = this.projetos.find(p => p.id === projetoId);
        },
        fecharModal() {
            this.projetoDetalhes = null;
        },
        abrirDetalhesTarefas(projeto) {
            this.modalTarefas = projeto;
        },
        fecharModalTarefas() {
            this.modalTarefas = null;
        }
    }
}
</script>

<style scoped>
.dashboard-full-width {
    max-width: 100%;
    padding-left: 1rem;
    padding-right: 1rem;
}
</style>
